// extracted by mini-css-extract-plugin
module.exports = {"cellGroup":"cell-group_cellGroup__1LZWA","highlighted":"cell-group_highlighted__3E2Vo"};